<template>
  <!-- <el-row v-loading="loading">
    <el-row v-if="editPanel.optType==='new' && editPanel.panelInfo.nodeType==='panel'">
      <el-col
        :span="18"
        style="height: 40px"
      >
        <el-radio
          v-model="inputType"
          label="new"
        > {{ $t('panel.custom') }}
        </el-radio>
        <el-radio
          v-model="inputType"
          label="new_outer_template"
        >{{ $t('panel.import_template') }}
        </el-radio>
        <el-radio
          v-model="inputType"
          label="new_inner_template"
          @click.native="getTree"
        >{{ $t('panel.copy_template') }}
        </el-radio>
      </el-col>
      <el-col
        v-if="inputType==='new_outer_template'"
        :span="6"
      >
        <el-button
          class="el-icon-upload"
          size="small"
          type="primary"
          @click="goFile"
        >{{ $t('panel.upload_template') }}
        </el-button>
        <input
          id="input"
          ref="files"
          type="file"
          accept=".DET"
          hidden
          @change="handleFileChange"
        >
      </el-col>
    </el-row>

    <el-row style="margin-top: 5px">
      <el-col :span="4">{{ editPanel.titleSuf }}{{ $t('commons.name') }}</el-col>
      <el-col :span="20">
        <el-input
          v-model="editPanel.panelInfo.name"
          clearable
          size="mini"
        />
      </el-col>
    </el-row>

    <el-row
      v-if="inputType==='new_inner_template'"
      class="preview mt10"
    >
      <el-col
        :span="8"
        style="height:100%;overflow-y: auto"
      >
        <template-all-list
          :template-list="templateList"
          @showCurrentTemplateInfo="showCurrentTemplateInfo"
        />
      </el-col>
      <el-col
        :span="16"
        :style="classBackground"
        class="preview-show"
      />
    </el-row>

    <el-row
      class="preview"
      :style="classBackground"
      v-if="inputType==='new_outer_template'"
    />
    <el-row class="root-class">
      <el-button
        size="mini"
        @click="cancel()"
      >{{ $t('commons.cancel') }}
      </el-button>
      <el-button
        type="primary"
        size="mini"
        :disabled="!saveStatus"
        @click="save()"
      >{{ $t('commons.confirm') }}
      </el-button>
    </el-row>
  </el-row> -->
  <!-- v-if="editPanel.optType==='new' && editPanel.panelInfo.nodeType==='panel'" -->
  <!-- v-if="editPanel.optType==='new' && editPanel.panelInfo.nodeType==='folder'" -->

  <el-row v-loading="loading">
    <el-row
      style="margin-top: 5px"
      v-if="editPanel.optType === 'newFirstFolder'"
    >
      <el-col :span="4"
        >{{ editPanel.titleSuf }}{{ $t("commons.name") }}</el-col
      >
      <el-col :span="20">
        <el-input v-model="editPanel.panelInfo.name" clearable size="mini" />
      </el-col>
    </el-row>

    <el-row
      v-if="
        editPanel.optType === 'new' && editPanel.panelInfo.nodeType === 'panel'
      "
    >
      <el-row class="alnCt">
        <el-col :span="4"><span class="isReq">*</span> 运动组</el-col>
        <el-col :span="20">
          <el-select v-model="teamId" placeholder="运动队" @change="changeTeam">
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in teamList"
              :key="index"
            ></el-option>
          </el-select>
          <el-select
            class="ml10"
            v-model="groupId"
            placeholder="运动组"
            @change="changeGroup"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in groupList"
              :key="index"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="alnCt mt10">
        <el-col :span="4"><span class="isReq">*</span>运动员</el-col>
        <el-col :span="20">
          <el-select v-model="userId" placeholder="成员" @change="changeMember">
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in memberList"
              :key="index"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="mt10 white">
        <el-col :span="4"><span class="isReq">*</span>应用模型</el-col>
        <el-col :span="20">
          <el-row class="preview">
            <el-col :span="6" style="height: 100%; overflow-y: auto">
              <template-all-list
                :template-list="templateList"
                :check-keys="checkKeys"
                @showCurrentTemplateInfo="showCurrentTemplateInfo"
                @getCurKeys="getCurKeys"
              />
            </el-col>
            <el-col :span="18" :style="classBackground" class="preview-show" />
          </el-row>
        </el-col>
      </el-row>
    </el-row>

    <el-row
      class="preview"
      :style="classBackground"
      v-if="inputType === 'new_outer_template'"
    />
    <el-row class="root-class">
      <el-button size="mini" @click="cancel()"
        >{{ $t("commons.cancel") }}
      </el-button>
      <el-button
        type="primary"
        size="mini"
        :disabled="!saveStatus"
        @click="save()"
        >{{ $t("commons.confirm") }}
      </el-button>
    </el-row>
  </el-row>
</template>

<script>
import { panelSave, panelUpdate, panelAuth } from "@/api/panel/panel";
import { showTemplateList } from "@/api/system/template";
import TemplateAllList from "./TemplateAllList";
import { deepCopy, imgUrlTrans } from "@/components/canvas/utils/utils";
import * as API_Member from "@/api/train/member";
import * as API_DataModel from "@/api/datamodel/index";

export default {
  components: { TemplateAllList },
  props: {
    editPanelOut: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      inputType: "new",
      fieldName: "name",
      tableRadio: null,
      keyWordSearch: "",
      columnLabel: this.$t("panel.belong_to_category"),
      templateList: [],
      importTemplateInfo: {
        thumbnail: "",
      },
      editPanel: null,
      templateSelected: false,
      userId: null,
      teamId: null,
      groupId: null,
      checkArr: [],
      teamList: [],
      groupList: [],
      memberList: [],
    };
  },
  computed: {
    saveStatus() {
      return (
        this.editPanel.panelInfo.name &&
        (this.inputType === "new" || this.templateSelected)
      );
    },
    classBackground() {
      if (this.importTemplateInfo.thumbnail) {
        return {
          background: `url(${imgUrlTrans(
            this.importTemplateInfo.thumbnail
          )}) no-repeat`,
        };
      } else {
        return {
          background: `#ececec`,
        };
      }
    },
  },
  watch: {
    inputType(newVal) {
      if (newVal === "new") {
        this.editPanel = deepCopy(this.editPanelOut);
      } else {
        this.templateSelected = false;
        this.editPanel.panelInfo.name = null;
        this.editPanel.panelInfo.panelStyle = null;
        this.editPanel.panelInfo.panelData = null;
        this.importTemplateInfo.thumbnail = null;
        this.editPanel.panelInfo.templateId = null;
      }
    },
  },
  created() {
    console.log(this.editPanelOut);
    this.editPanel = deepCopy(this.editPanelOut);
    // this.getTree()
    this._getTeam();
  },
  mounted() {
    this.bindKey();
  },
  destroyed() {
    this.unBindKey();
  },
  methods: {
    entryKey(event) {
      const keyCode = event.keyCode;
      if (keyCode === 13) {
        this.save();
      }
    },
    bindKey() {
      document.addEventListener("keypress", this.entryKey);
    },
    unBindKey() {
      document.removeEventListener("keypress", this.entryKey);
    },
    showCurrentTemplateInfo(data) {
      // console.log(data);
      // console.log(data.nodeType);
      // console.log(data.thumbnail);
      this.editPanel.panelInfo.templateId = data.id;
      if (data.nodeType === "folder") {
        this.editPanel.panelInfo.name = null;
        this.importTemplateInfo.thumbnail = null;
        this.templateSelected = false;
      } else {
        this.editPanel.panelInfo.name = data.name;
        this.importTemplateInfo.thumbnail = data.thumbnail;
        this.templateSelected = true;
      }
    },
    getCurKeys(data) {
      // console.log(data);
      this.checkArr = data;
    },
    getTree() {
      const request = {
        level: "-1",
        withChildren: true,
      };
      this.loading = true;
      showTemplateList(request).then((res) => {
        this.templateList = res.data;
        this.loading = false;
      });
    },
    handleExceed(file) {},
    cancel() {
      this.$emit("closeEditPanelDialog");
    },
    save() {
      console.log(this.editPanel.panelInfo);
      if (
        this.editPanel.optType === "newFirstFolder" &&
        !this.editPanel.panelInfo.name
      ) {
        this.$warning(this.$t("chart.name_can_not_empty"));
        return false;
      }

      if (this.editPanel.panelInfo.name.length > 50) {
        this.$warning(this.$t("commons.char_can_not_more_50"));
        return false;
      }

      if (
        !this.editPanel.panelInfo.templateId &&
        this.editPanel.optType === "new" &&
        this.inputType === "new_inner_template"
      ) {
        this.$warning(this.$t("chart.template_can_not_empty"));
        return false;
      }
      this.editPanel.panelInfo["newFrom"] = this.inputType;
      if (
        this.editPanel.optType === "new" ||
        this.editPanel.optType === "newFirstFolder"
      ) {
        if (this.editPanel.optType === "newFirstFolder") {
          this.loading = true;
          panelSave(this.editPanel.panelInfo)
            .then((response) => {
              this.$message({
                message: this.$t("commons.save_success"),
                type: "success",
                showClose: true,
              });
              this.loading = false;
              this.$emit("closeEditPanelDialog", response.data);
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          let params = {
            authSourceType: "panel", //写死
            authTargetType: "user", //写死
            userId: this.userId,
            sourceIds: this.checkArr,
          };
          if (!params.userId) {
            this.$message({
              message: "请选择运动员",
              type: "error",
              showClose: true,
            });
            return;
          }
          if (!params.sourceIds.length) {
            this.$message({
              message: "请选择应用模型",
              type: "error",
              showClose: true,
            });
            return;
          }
          console.log(params);
          this.loading = true;
          panelAuth(params)
            .then((res) => {
              this.$message({
                message: this.$t("commons.save_success"),
                type: "success",
                showClose: true,
              });
              this.loading = false;
              this.$emit("closeEditPanelDialog");
            })
            .catch(() => {
              this.loading = false;
            });
        }
      } else {
        panelUpdate(this.editPanel.panelInfo)
          .then((response) => {
            this.$message({
              message: this.$t("commons.save_success"),
              type: "success",
              showClose: true,
            });
            this.loading = false;
            this.$emit("closeEditPanelDialog", response.data);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (res) => {
        this.templateSelected = true;
        const result = res.target.result;
        this.importTemplateInfo = JSON.parse(result);
        this.editPanel.panelInfo.name = this.importTemplateInfo.name;
        this.editPanel.panelInfo.panelStyle =
          this.importTemplateInfo.panelStyle;
        this.editPanel.panelInfo.panelData = this.importTemplateInfo.panelData;
        this.editPanel.panelInfo.dynamicData =
          this.importTemplateInfo.dynamicData;
        this.editPanel.panelInfo.staticResource =
          this.importTemplateInfo.staticResource;
      };
      reader.readAsText(file);
    },
    goFile() {
      this.$refs.files.click();
    },
    _getTeam() {
      API_Member.teamList().then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.teamList = res.data;
          this.teamId = res.data[0].id;
          this._getGroup();
        }
      });
    },
    _getGroup() {
      API_Member.groupList({ teamId: this.teamId }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.groupList = res.data;
          this.groupId = res.data[0].id;
          this._getMember();
        }
      });
    },
    _getMember() {
      API_Member.memberAll({ groupId: this.groupId, type: 2 }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.memberList = res.data;
          if(res.data.length) {
            this.userId = res.data[0].id;
            this._modelList();
          } else {
            this.userId = ''
            this.templateList = []
          }
        }
      });
    },
    changeTeam(e) {
      this.groupList = [];
      this.groupId = null;
      this._getGroup();
    },
    changeGroup(e) {
      this.memberList = [];
      this.memberId = null;
      this._getMember();
    },
    changeMember(e) {
      this.userId = e;
      this._modelList();
    },
    _modelList() {
      API_DataModel.modelList({
        applyType: "personal",
        nodeType: "panel",
      }).then((res) => {
        console.log(res);
        this.templateList = res.data;
        this.getShow();
      });
    },
    getShow() {
      API_DataModel.modelEcho(this.userId).then((res) => {
        // console.log(res);
        this.checkKeys = res.data.map((item) => item.id);
        this.$forceUpdate();
        // console.log(this.checkKeys);
      });
    },
  },
};
</script>

<style scoped>
.isReq {
  color: #f56c6c;
  margin-right: 4px;
}
.white {
  color: #fff;
}
.my_table ::v-deep .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0 0;
}

.my_table ::v-deep .el-table th.is-leaf {
  /* 去除上边框 */
  border: none;
}

.my_table ::v-deep .el-table::before {
  /* 去除下边框 */
  height: 0;
}

.root-class {
  margin: 15px 0px 5px;
  text-align: center;
}

.preview {
  border: 1px solid rgba(255, 255, 255, 0.1);
  height: 440px !important;
  overflow: hidden;
  background-size: 100% 100% !important;
}

.preview-show {
  height: 100%;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  background-size: 100% 100% !important;
}
</style>
